import React from 'react'
import style from '../scss/components/Guarantee.module.scss'
import { Fade } from "react-awesome-reveal"
import guaranteeImg from '../assets/guarantee.png'
import Button from "./Button"

const Guarantee = () => {
    return (
        <Fade direction={'up'} triggerOnce={true}>
            <div className={style.Container}>
                <div className={style.Logo}>
                    <img src={guaranteeImg} width={150} height={150} alt={''}/>
                </div>
                <h2>
                    Muide – me anname Sulle ka <strong>100/100 garantii!</strong>
                </h2>
                <div className={style.Content}>
                    <p>
                        Seniste koolitusel osalenute tagasiside on näidanud,
                        et kui SalonSecretsi kursusel omandatud teadmised ja tööriistad ka oma salongitöösse rakendada,
                        on tulemused tõesti märkimisväärsed ja üliedukad.
                    </p>
                    <p>
                        Oleme kindlad, et SalonSecrets on ka Sinu salongi jaoks elumuutev,
                        mistõttu anname Sulle omapoolse 100/100 garantii.
                    </p>
                    <p>
                        Vaata meie veebikursus läbi, pane saadud teadmised oma salongis proovile ja kui tunned 100 päeva jooksul,
                        et kuigi rakendasid kõiki parimaid taktikaid ja strateegiaid ka oma salongis, aga need siiski ei täitnud Sinu ootusi,
                        kirjuta meile <a href="mailto:info@salon.life">info@salon.life</a> ja kanname Sulle 100% ulatuses raha tagasi.
                        Ja boonusmaterjalid võid jätta endale – tänutäheks, et meile võimaluse andsid!
                    </p>
                </div>
                <Button inverted mobile16={true} onClick={() => window.location.href = '#offer'}>
                    Soovin koolitusega alustada
                </Button>
            </div>
        </Fade>
    )
}

export default Guarantee
